import { render, staticRenderFns } from "./EndingInterventions.vue?vue&type=template&id=494d7666&scoped=true"
import script from "./EndingInterventions.vue?vue&type=script&lang=js"
export * from "./EndingInterventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d7666",
  null
  
)

export default component.exports